export function formatMoney(value, currency = "ARS", locale = "es-AR") {
  const amount = Number(value);

  const safeAmount = Number.isFinite(amount) ? amount : 0;
  const code = String(currency || "ARS").toUpperCase();
  const options = { maximumFractionDigits: 2, minimumFractionDigits: 0 };
  // Evitar el símbolo ambiguo "$" o "US$" en publicaciones cotizadas en USD.
  if (code === "USD") return `USD ${new Intl.NumberFormat(locale, options).format(safeAmount)}`;
  return new Intl.NumberFormat(locale, {
    style: "currency", currency: code, ...options,
  }).format(safeAmount);
}
